
// 관리자 IP 설정
//
// @since 2018-10-04
// @Created By jupil.Go <devp018>

import { i18n } from '~/plugins/i18n'
import { CmApiPrefix as apiPrefix } from '~/utils/restApi'

const initAdminIpPageData = (ccFlag = true) => {
  return {
    admin_ip_cm_id: 0, // (integer) ID
    admin_ip_cm_ip_ver_type: 1, // required (one of 1, 2) IP 버전 종류(IPv4: 1, IPv6: 2)
    admin_ip_cm_ip: '', // required (string) IP 주소(IPv4 Address or IPv6 Address)
    admin_ip_cm_mac: '', // (string) MAC 주소
    admin_ip_cm_prefix: ccFlag ? 32 : 24, // required (integer) Prefix(IPv4 범위: 24-32, IPv6 범위: 64-128)
    admin_ip_cm_device_type: 1, // 관리자 통합 설정 장비 유형, 1 All, 2 장비 선택
    admin_ip_cm_desc: '', // (string - maxLength: 128) 설명
    admin_cm_device: [], // (Array[Inline Model 2], optional): 관리자 일반 통합 설정 장비 ,
    device_id: [] // 장비리스트, admin_ip_cm_device_type = 2 일 경우 필수
  }
}

export const state = () => ({
  selectedItem: {},
  adminIpDataList: [],
  adminIpPageData: initAdminIpPageData()
})

export const mutations = {
  // 리스트 조회
  getAdminIpList (state, item) {
    state.adminIpDataList = Object.freeze(_.cloneDeep(item))
  },
  delAdminIp (state, itemList) {
    const adminIpDataList = _.cloneDeep(state.adminIpDataList)

    for (const itemKey of itemList.admin_ip_cm_id_list) {
      const idx = _.findIndex(adminIpDataList, {admin_ip_cm_id: itemKey})
      if (idx >= 0) {
        adminIpDataList.splice(idx, 1)
      }
    }
    state.adminIpDataList = Object.freeze(adminIpDataList)
  },
  setAdminIpDialog (state, data) {
    state.selectedItem = data
    state.adminIpPageData = data
  },
  clearAdminIpDialog (state) {
    state.adminIpPageData = initAdminIpPageData()
  }
}

export const actions = {
  // 리스트 조회
  async getAdminIpList ({commit, state}, isShowLoading) {
    let res = { code: 'ok', result: {} }
    try {
      let axiosParam = {}
      if (isShowLoading !== undefined && isShowLoading === false) {
        axiosParam = {loading: false}
      }

      res = await this.$axios.$get(`${apiPrefix}/managers-cm-ip/0`, axiosParam)
      if (res.code === 'ok') {
        commit('getAdminIpList', res.result)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  async getAdminIpData ({commit, state}, adminIpCmId) {
    if (typeof adminIpCmId === 'undefined') {
      return
    }

    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$get(`${apiPrefix}/managers-cm-ip/${adminIpCmId}`)
      if (res.code === 'ok') {
        commit('setAdminIpDialog', res.result[0])
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  async addAdminIp ({commit, state}) {
    let res = { code: 'ok', result: {} }
    try {
      const params = {
        admin_ip_cm_desc: state.adminIpPageData.admin_ip_cm_desc,
        admin_ip_cm_ip: state.adminIpPageData.admin_ip_cm_ip,
        admin_ip_cm_device_type: state.adminIpPageData.admin_ip_cm_device_type,
        admin_ip_cm_mac: state.adminIpPageData.admin_ip_cm_mac || null,
        admin_ip_cm_ip_ver_type: state.adminIpPageData.admin_ip_cm_ip_ver_type,
        admin_ip_cm_prefix: state.adminIpPageData.admin_ip_cm_prefix,
        device_id: state.adminIpPageData.device_id
      }

      res = await this.$axios.$post(`${apiPrefix}/managers-cm-ip`, params)

      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  async edtAdminIp ({commit, dispatch, state}) {
    let res = { code: 'ok', result: {} }
    try {
      // _.cloneDeep(state.adminIpPageData)
      const params = {
        admin_ip_cm_desc: state.adminIpPageData.admin_ip_cm_desc,
        admin_ip_cm_ip: state.adminIpPageData.admin_ip_cm_ip,
        admin_ip_cm_device_type: state.adminIpPageData.admin_ip_cm_device_type,
        admin_ip_cm_mac: state.adminIpPageData.admin_ip_cm_mac || null,
        admin_ip_cm_ip_ver_type: state.adminIpPageData.admin_ip_cm_ip_ver_type,
        admin_ip_cm_prefix: state.adminIpPageData.admin_ip_cm_prefix,
        device_id: state.adminIpPageData.device_id
      }

      res = await this.$axios.$put(`${apiPrefix}/managers-cm-ip/${state.adminIpPageData.admin_ip_cm_id}`,
        params,
        {
          alertMsg: i18n.t('msg.updateApply')
        })
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  async delAdminIp ({commit, state}, param) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$put(`${apiPrefix}/managers-cm-ip`,
        param.idList,
        {
          alertMsg: i18n.t('msg.removeApply')
        })
      if (res.code === 'ok') {
        commit('delAdminIp', param.idList)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  async finalCommand ({commit, state}, type) {
    let res = { code: 'ok', result: {} }
    try {
      const axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
      res = await this.$axios.$put(`${apiPrefix}/managers-cm-ip/${type}`, void 0, axiosConfig)
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  }
}

export const getters = {}

export const strict = false
